module.exports = __webpack_public_path__ + "dbd098f4f6f6db56057c02a34fed2948.MP3";